import { render, staticRenderFns } from "./RelatedCompanies.vue?vue&type=template&id=d4afe48c&"
import script from "./RelatedCompanies.vue?vue&type=script&lang=js&"
export * from "./RelatedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCompanies.vue?vue&type=style&index=0&id=d4afe48c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports